"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const camelize_1 = __importDefault(require("camelize"));
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const config_1 = require("config");
const utils_1 = require("utils");
const slice_1 = require("./slice");
const Views = __importStar(require("./views"));
function Routes() {
    const { path } = (0, react_router_dom_1.useRouteMatch)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { receiptIdEncoded } = (0, react_router_dom_1.useParams)();
    const history = (0, react_router_dom_1.useHistory)();
    const token = (0, react_redux_1.useSelector)((state) => state.root.creditPortal.receipt.token);
    (0, react_1.useEffect)(() => {
        try {
            const receiptInfoDecoded = (0, camelize_1.default)(JSON.parse(atob(receiptIdEncoded ?? '')));
            receiptInfoDecoded &&
                dispatch((0, slice_1.setToken)(receiptInfoDecoded.emailToken ?? receiptInfoDecoded.smsToken));
        }
        catch (e) {
            (0, utils_1.toastError)('Invalid Receipt URL');
            history.push(config_1.CREDIT_PORTAL_URL);
        }
    }, []);
    if (receiptIdEncoded === null) {
        history.push(config_1.CREDIT_PORTAL_URL);
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }
    if (!token) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }
    return ((0, jsx_runtime_1.jsxs)(react_router_dom_1.Switch, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { exact: true, path: (0, config_1.makePath)(path, '/success'), children: (0, jsx_runtime_1.jsx)(Views.ESignSuccess, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: (0, config_1.makePath)(path, '/transaction-voided'), children: (0, jsx_runtime_1.jsx)(Views.ESignErrorBecauseOfStatus, { status: "voided" }) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: (0, config_1.makePath)(path, '/transaction-canceled'), children: (0, jsx_runtime_1.jsx)(Views.ESignErrorBecauseOfStatus, { status: "canceled" }) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: path, children: (0, jsx_runtime_1.jsx)(Views.ESign, {}) })] }));
}
exports.default = Routes;
